export enum ScoreFieldNames {
    EVALUATOR_SCORE = 'evaluatorScore',
}

export enum JaggedAnalysisStatus {
    NOT_REQUIRED = 'NOT_REQUIRED',
    PENDING = 'PENDING',
    JAGGED = 'JAGGED',
    NOT_JAGGED = 'NOT_JAGGED',
    PENDING_EOR = 'PENDING_EOR',
    COMPLETE_EOR = 'COMPLETE_EOR',
}

export enum ExplanationOfGradesStatus {
    NOT_CREATED = 'NOT_CREATED',
    DRAFT = 'DRAFT',
    READY = 'READY',
    PUBLISHED = 'PUBLISHED',
    OPENED = 'OPENED',
}

export enum ExplanationOfGradesRequestStatus {
    REQUESTED = 'REQUESTED',
    NOT_REQUESTED = 'NOT_REQUESTED',
}

export type QuestionEvaluatorAssignment = {
    evaluatorId: number;
    evaluatorName: string;
    committeeId?: number;
    committeeName?: string;
}

export enum GradingPartySubmissionStatus {
    NOT_SUBMITTED = 'not_submitted',
    SUBMITTED = 'submitted',
    SUBMITTED_BLANK = 'submitted_blank',
    SUBMITTED_WITHDRAWN = 'submitted_withdrawn',
    DELETED = 'deleted',
}

export type EvaluatorScoreEntry = {
    evaluationRound: number;
    evaluatorBaseScore: number;
    evaluatorId: number;
    evaluatorName: string;
    evaluatorScore: number;
    flagged: boolean;
    lastEdited: string;
};
